import { FC } from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { ROUTES } from "modules/home/enums/routes.enum";
import { ILocationState } from "core/interfaces/route-location-state.interface";
import { userService } from "core/services/user.service";

interface PublicRouteProps extends RouteProps {
    restricted?: boolean;
}

export const PublicRoute: FC<PublicRouteProps> = ({
    restricted = false,
    component: Component,
    children,
    ...rest
}) => {
    const { token } = userService.getToken();

    return (
        <Route
            {...rest}
            render={(routeProps) => {
                const locationState: ILocationState = {
                    from: {
                        pathname: routeProps.location.pathname,
                    },
                };

                return token && restricted ? (
                    <Redirect
                        to={{
                            pathname: ROUTES.HOME,
                            state: locationState,
                        }}
                    />
                ) : (
                    children ?? <Component {...routeProps} />
                );
            }}
        />
    );
};
